import { normalizeIntegrationName } from '@/components/integrations/integrations';
import { $apiAllo } from '@/services/api-allo/client';
import { useMemo } from 'react';

export const POWER_DIALER_SUPPORTED_CRMS = ['attio', 'hubspot'] as const;

export type PowerDialerSupportedCrm = (typeof POWER_DIALER_SUPPORTED_CRMS)[number];

type Integration = {
  type?: string;
  status?: string;
};

export const useConnectedPowerDialerCrms = (): {
  connectedCrms: PowerDialerSupportedCrm[];
  hasConnectedCrm: boolean;
  isLoading: boolean;
} => {
  const { data, isLoading } = $apiAllo.useQuery('get', '/v1/business/integrations', {});

  const connectedCrms = useMemo<PowerDialerSupportedCrm[]>(() => {
    const integrations = (Array.isArray(data) ? data : []) as Integration[];
    const enabledTypes = new Set(
      integrations
        .filter((i) => i.status === 'ENABLED' && typeof i.type === 'string')
        .map((i) => normalizeIntegrationName(i.type as string)),
    );
    return POWER_DIALER_SUPPORTED_CRMS.filter((crm) => enabledTypes.has(crm));
  }, [data]);

  return {
    connectedCrms,
    hasConnectedCrm: connectedCrms.length > 0,
    isLoading,
  };
};
